import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/reducers';
import { sessionConnectionType } from 'src/app/session/store/session.selectors';
import { map, withLatestFrom } from 'rxjs/operators';
import { XTargetUpdated } from 'src/app/session/store/session.actions';


@Injectable()
export class ConnectionTypeInterceptor implements HttpInterceptor {

	private readonly XTARGET_HEADER_RESPONSE: string = 'X-Target';

	constructor( private store: Store<AppState> ) {
	}

	intercept( req: HttpRequest<any>, next: HttpHandler ): Observable<HttpEvent<any>> {
		return next.handle( req ).pipe(
				withLatestFrom( this.store.select( sessionConnectionType ) ),
				map( ([ response, connectionType ]) => {
					if( ( connectionType == null || connectionType.length == 0 ) && response instanceof HttpResponse ) {
						connectionType = response.headers.get( this.XTARGET_HEADER_RESPONSE );
						if( connectionType && connectionType.length > 0 )
							this.store.dispatch( new XTargetUpdated( { connectionType } ) );
					}
					return response;
				})
			);
	}

}